import config from '../config/config';
/* let CONFIG_DATA = {};

export function setNavConfigData(data) {
  CONFIG_DATA = data;
} */
export const PRODUCT_TYPE = {
  ACTIVE_PLUS_PORTFOLIOS: 'APP',
  BROKERAGE: 'Brokerage',
  MUTUAL_FUND: 'MutualFund',
  NAT529: 'NAT529',
  MD529: 'MD529',
  AK529: 'AK529',
  RAS: 'RAS',
};

const PRODUCT_LINKS = {};

PRODUCT_LINKS[PRODUCT_TYPE.ACTIVE_PLUS_PORTFOLIOS] = {
  order: 1,
};

PRODUCT_LINKS[PRODUCT_TYPE.RAS] = {
  order: 2,
};

PRODUCT_LINKS[PRODUCT_TYPE.BROKERAGE] = {
  order: 3,
};

PRODUCT_LINKS[PRODUCT_TYPE.MUTUAL_FUND] = {
  order: 4,
};

PRODUCT_LINKS[PRODUCT_TYPE.NAT529] = {
  order: 5,
  contactUs: {
    id: 'nav-nat-contact-us',
    label: 'Contact Us',
    href: 'https://www.troweprice.com/personal-investing/troweprice-529/contact-us.html',
  },
  privacyPolicy: {
    label: 'Privacy Policy',
    id: 'nav-nat529-privacy-policy-link',
    href: 'https://www.troweprice.com/privacy',
  },
};

PRODUCT_LINKS[PRODUCT_TYPE.MD529] = {
  order: 6,
  contactUs: {
    id: 'nav-md-contact-us',
    label: 'Contact Us',
    href: 'https://maryland529.com/Contact-Us1',
  },
  privacyPolicy: {
    id: 'nav-md-privacy-policy',
    label: 'Privacy Policy',
    href: 'https://maryland529.com/Privacy-Statement',
  },
};

PRODUCT_LINKS[PRODUCT_TYPE.AK529] = {
  order: 7,
  contactUs: {
    id: 'nav-ak-contact-us',
    label: 'Contact Us',
    href: 'https://www.alaska529plan.com/about-us/contact-us.html',
  },
  privacyPolicy: {
    id: 'nav-ak-privacy-policy',
    label: 'Privacy Policy',
    href: 'https://www.alaska529plan.com/privacy-statement.html',
  },
};

const NAV_MODEL = {
  socialLinks: [
    {
      label: 'Facebook',
      id: 'facebook-link',
      icon: 'icon-fb',
      href: 'https://www.facebook.com/troweprice',
    },
    {
      label: 'Twitter',
      id: 'twitter-link',
      icon: 'icon-tw',
      href: 'https://twitter.com/troweprice',
    },
    {
      label: 'YouTube',
      id: 'youtube-link',
      icon: 'icon-yt',
      href: 'https://www.youtube.com/trowepricegroup',
    },
    {
      label: 'LinkedIn',
      id: 'linkedin-link',
      icon: 'icon-ln',
      href: 'https://www.linkedin.com/company/157329?trk=tyah',
    },
  ],
  corpLinks: [
    {
      label: 'Company Overview',
      id: 'componay-overview-link',
      href: `${config.url}/corporate/en/what-we-do.html`,
    },
    {
      label: 'Responsibility',
      id: 'corporate-responsibility-link',
      href: `${config.url}/corporate/en/what-sets-us-apart/corporate-responsibility.html`,
    },
    {
      label: 'Careers',
      id: 'careers-link',
      href: `${config.url}/corporate/en/careers.html`,
    },
    {
      label: 'Investor Relations',
      id: 'investor-relations-link',
      href: 'https://troweprice.gcs-web.com/',
    },
    {
      label: 'Press Releases',
      id: 'press-releases-link',
      href: `${config.url}/corporate/en/press.html`,
    },
  ],
  legalLinks: [
    {
      label: 'Site Map',
      id: 'site-map-link',
      href: `${config.url}/personal-investing/sitemap.html`,
    },
    {
      label: 'U.S. & Canada Privacy Notice',
      id: 'generic-privacy-policy-link',
      href: `${config.url}/privacy`,
    },
    {
      label: 'Terms of Use',
      id: 'terms-of-use-link',
      href: `${config.url}/personal-investing/help/terms-of-use.html`,
    },
    {
      label: 'Security Measures',
      id: 'security-link',
      href: `${config.url}/personal-investing/help/policies-and-security/security.html`,
    },
    {
      label: 'Legal Information',
      id: 'legal-info-link',
      href: `${config.url}/personal-investing/help/policies-and-security/legal-information.html`,
    },
    {
      label: 'Customer Agreement',
      id: 'customer-agreement-link',
      href: `${config.url}/personal-investing/help/policies-and-security/customer-agreement.html`,
    },
  ],
  feedback: {
    label: '[+] Feedback',
    id: 'feedback-plus-link',
    link: '',
  },
  mobileSolution: {
    label: 'Mobile Solutions',
    id: 'mobile-solutions-link',
    href: `${config.url}/corporate/en/mobile-solutions.html`,
  },
  contactUs: {
    label: 'Contact Us',
    id: 'generic-contact-us-link',
    href: `${config.url}/personal-investing/help/contact-us.html`,
  },
  footerContent: '',
  otherPrivacyPolicies: [],
};

export function getFooterModel(products) {
  const links = Object.assign({}, NAV_MODEL, PRODUCT_LINKS);
  const hasMD529 = products.indexOf(PRODUCT_TYPE.MD529) >= 0;
  const hasAK529 = products.indexOf(PRODUCT_TYPE.AK529) >= 0;
  const hasNAT529 = products.indexOf(PRODUCT_TYPE.NAT529) >= 0;

  const hasGeneral = products.some(
    (p) =>
      [
        PRODUCT_TYPE.ACTIVE_PLUS_PORTFOLIOS,
        PRODUCT_TYPE.BROKERAGE,
        PRODUCT_TYPE.MUTUAL_FUND,
        PRODUCT_TYPE.RAS,
      ].indexOf(p) >= 0
  );

  if (hasAK529) {
    if (PRODUCT_LINKS[PRODUCT_TYPE.AK529].privacyPolicy) {
      links.otherPrivacyPolicies.push(
        PRODUCT_LINKS[PRODUCT_TYPE.AK529].privacyPolicy
      );
    }
    links.contactUs =
      PRODUCT_LINKS[PRODUCT_TYPE.AK529].contactUs || NAV_MODEL.contactUs;
  }

  if (hasMD529) {
    if (PRODUCT_LINKS[PRODUCT_TYPE.MD529].privacyPolicy) {
      links.otherPrivacyPolicies.push(
        PRODUCT_LINKS[PRODUCT_TYPE.MD529].privacyPolicy
      );
    }
    links.contactUs =
      PRODUCT_LINKS[PRODUCT_TYPE.MD529].contactUs || NAV_MODEL.contactUs;
  }

  if (hasNAT529) {
    if (PRODUCT_LINKS[PRODUCT_TYPE.NAT529].privacyPolicy) {
      links.otherPrivacyPolicies.push(
        PRODUCT_LINKS[PRODUCT_TYPE.NAT529].privacyPolicy
      );
    }
    links.contactUs =
      PRODUCT_LINKS[PRODUCT_TYPE.NAT529].contactUs || NAV_MODEL.contactUs;
  }

  if (
    !hasGeneral &&
    ((hasMD529 && (hasAK529 || hasNAT529)) || (hasAK529 && hasNAT529))
  ) {
    links.otherPrivacyPolicies = [];
    links.contactUs = NAV_MODEL.contactUs;
    NAV_MODEL.legalLinks[1] = {
      label: 'Privacy Policy',
      id: 'generic-privacy-policy-link',
      href: `${config.url}/personal-investing/help/policies-and-security/privacy.html`,
    };
  }

  if (hasGeneral) {
    // Override any previously set contactUs link with general.
    links.contactUs = NAV_MODEL.contactUs;
    links.otherPrivacyPolicies = [];
  }

  // modified NAV_MODEL
  return links;
}

export const appendBasePath = (relativeRoute) => {
  const basePath = config.basePath;
  return `${basePath}${relativeRoute}`;
};
